import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n } from "react/jsx-runtime";
//#region src/components/icons/MinusIcon.tsx
var r = (e) => /* @__PURE__ */ n(t, {
	viewBox: "0 0 24 24",
	fill: "none",
	...e,
	children: /* @__PURE__ */ n("path", {
		d: "M19 11C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11H19Z",
		fill: "currentColor"
	})
}), i = {
	12: {
		Artwork: r,
		width: 12,
		height: 12
	},
	16: {
		Artwork: (e) => /* @__PURE__ */ n(t, {
			viewBox: "0 0 16 16",
			fill: "none",
			...e,
			children: /* @__PURE__ */ n("path", {
				d: "M12.6665 7.25C13.0807 7.25 13.4165 7.58579 13.4165 8C13.4165 8.41421 13.0807 8.75 12.6665 8.75H3.3335C2.91928 8.75 2.5835 8.41421 2.5835 8C2.5835 7.58579 2.91928 7.25 3.3335 7.25H12.6665Z",
				fill: "currentColor"
			})
		}),
		width: 16,
		height: 16
	},
	20: {
		Artwork: r,
		width: 20,
		height: 20
	},
	24: {
		Artwork: r,
		width: 24,
		height: 24
	}
}, a = ({ size: t = 16, tone: r = "default", className: a, ...o }) => /* @__PURE__ */ n(e, {
	source: i[t],
	monochrome: !0,
	className: ["pf-icon-" + r, a].filter(Boolean).join(" "),
	...o
});
//#endregion
export { a as MinusIcon };
